// store/modules/user.js



import { getlanguage, getGuide, setGuide,setlanguage } from "@/utils/auth";

import { baseURL } from '@/api/config'

export default {
    namespaced: true, // 命名空间模块化
    state: () => ({
        lang: getlanguage() || 'en-US',
        toRouter: {
            name: 'Layout',
            params: {},
            query: {}
        },
        fromRouter: {
            name: 'Layout',
            params: {},
            query: {}
        },

        baseURL: baseURL,
        isGuide: false,
        guide: getGuide(),
        upStep: '',
        tabPath: '',
        versionName: ''
    }),
    mutations: {
        SET_TO_ROUTE(state, obj) {
            state.toRouter = obj;
        },
        SET_FROM_ROUTE(state, obj) {
            state.fromRouter = obj;
        },
        SETUPSTEP: (state, step) => {
            state.upStep = step;
        },
        SET_GUIDE(state, obj) {
            state.guide = obj.guide;
            if(obj.versionName) {
                state.versionName = obj.versionName;
            }
        },
        SET_IS_GUIDE(state,isGuide) {
            state.isGuide = isGuide;
        },
        SETLANG: (state, lang) => {
            state.lang = lang;
        },
        SET_TAB_PATH: (state, path) => {
            state.tabPath = path;
        },
    },
    actions: {
        setUpStep({ commit },step ) {
            commit("SETUPSTEP", step);
        },
        setGuide({ commit }, obj) {
            commit("SET_GUIDE", obj);
            setGuide(obj.guide)
        },
        setIsGuide({ commit }, isGuide) {
            commit("SET_IS_GUIDE", isGuide);
        },
        setLang({ commit }, lang) {
            setlanguage(lang)
            commit("SETLANG", lang);
        },
        setTabPath({ commit }, path) {
            commit("SET_TAB_PATH", path);
        },
    },
    getters: {
        isAuthenticated(state) {
            return !!state.userInfo;
        },
    },
};
